import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Form } from "react-bootstrap";

interface CustomDatePickerProps {
  selectedDate: Date | null;
  onChange: (date: Date | null) => void;
  label: string;
  disabled?: boolean;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({ selectedDate, onChange, label, disabled }) => {
  const [isFocused, setIsFocused] = useState(false);
  const today = new Date(); // Data de hoje

  return (
    <Form.Group className="position-relative w-100">
      <div className="position-relative" style={{ height: "48px" }}>
        {/* Label dentro do input */}
        <Form.Label
          style={{
            position: "absolute",
            top: selectedDate || isFocused ? "1px" : "40%",
            left: "8px",
            fontSize: selectedDate || isFocused ? "12px" : "0.85rem",
            fontFamily: "var(--bs-body-font-family)",
            color: "#6c757d",
            padding: "0 5px",
            transform: selectedDate || isFocused ? "none" : "translateY(-50%)",
            transition: "all 0.2s ease-out",
            pointerEvents: "none",
            zIndex: 10,
          }}
        >
          {label}
        </Form.Label>

        {/* Campo de Data - Bloqueando dias futuros completamente */}
        <DatePicker
          selected={selectedDate}
          onChange={onChange}
          className="form-control"
          dateFormat="dd/MM/yyyy"
          isClearable
          maxDate={today} // 🔥 Bloqueia a seleção de dias futuros
          disabled={disabled}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          popperPlacement="bottom-start"
          wrapperClassName="w-100"
          filterDate={(date) => date <= today} // 🔥 Evita a seleção clicável de dias futuros
          customInput={
            <input
              style={{
                height: "40px",
                width: "100%",
                fontSize: "14px",
                paddingLeft: "12px",
                paddingTop: "14px",
              }}
            />
          }
        />
      </div>
    </Form.Group>
  );
};

export default CustomDatePicker;
